import { render, staticRenderFns } from "./StockAdd.vue?vue&type=template&id=5f49b802&scoped=true"
import script from "./StockAdd.vue?vue&type=script&lang=js"
export * from "./StockAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f49b802",
  null
  
)

export default component.exports